import { render } from "./addNotice.vue?vue&type=template&id=3083da4d&scoped=true"
import script from "./addNotice.vue?vue&type=script&lang=js"
export * from "./addNotice.vue?vue&type=script&lang=js"

import "./addNotice.vue?vue&type=style&index=0&id=3083da4d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3083da4d"

export default script